import { render } from "./Receive.vue?vue&type=template&id=9b36dc94&ts=true&lang=pug"
import script from "./Receive.vue?vue&type=script&setup=true&lang=ts"
export * from "./Receive.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__